export const Logo = ({ light = true }) => (
  <div className="leading-none" data-testid="nav-logo">
    <div className={`font-bold tracking-[0.22em] text-base ${light ? "text-white" : "text-[#0F1E3D]"}`}>
      ATLANTIS
    </div>
    <div className="eyebrow text-[9px] text-[#C5B358] mt-1.5">INTERNATIONAL</div>
  </div>
);

export default Logo;